<template>
  <div v-if="examinationPaper" class="examinationPaper">

    <div class="title">
      {{ $t('exam.PAPER') }} #{{ examinationPaper.number }} {{ examinationPaper.title }}
    </div>

    <div
      class="content"
      v-html="examinationPaper.content">

    </div>
  </div>

</template>

<script>
export default {
  name: 'ExaminationPaper',
  props: {
    examinationPaper: Object
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.examinationPaper {
  margin-bottom: 32px;

  .title {
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 24px;
  }

  .content {
    padding: 24px;
    background-color: $paper-bg;
    box-shadow: 0 1px 2px rgba(0,150,136,0.6);
  }
}

</style>
